import * as React from "react";

function SvgRestoreFromDatabase(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 34 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.0134 24.3824C16.9739 24.9902 17.4824 25.4919 18.0897 25.4442L22.272 25.1157C23.1262 25.0486 23.5059 24.0086 22.8961 23.4069L21.8851 22.4094C22.2535 21.9659 22.7425 21.636 23.2953 21.4612C23.9218 21.2631 24.5959 21.2751 25.215 21.4953C25.834 21.7156 26.3642 22.132 26.7248 22.6813C27.0854 23.2306 27.2567 23.8827 27.2126 24.5383C27.1685 25.1939 26.9114 25.8171 26.4805 26.3132C26.0496 26.8092 25.4684 27.1509 24.8254 27.2863C24.1824 27.4216 23.5128 27.3432 22.9185 27.063C22.3242 26.7828 21.8377 26.316 21.533 25.7339L18.8185 27.1544C19.4327 28.3282 20.4136 29.2692 21.6119 29.8342C22.8101 30.3991 24.1602 30.5572 25.4565 30.2843C26.7529 30.0114 27.9246 29.3225 28.7934 28.3224C29.6622 27.3222 30.1805 26.0657 30.2694 24.7439C30.3583 23.4221 30.013 22.1074 29.286 21C28.5589 19.8925 27.49 19.0528 26.2419 18.6088C24.9937 18.1647 23.6347 18.1406 22.3716 18.54C21.341 18.8659 20.4203 19.4592 19.7002 20.2537L18.986 19.549C18.3761 18.9473 17.3413 19.341 17.2857 20.196L17.0134 24.3824Z"
        fill="#414042"
      />
      <path
        d="M27.2708 7.23511V4.45239C27.2708 2.00008 21.1633 0 13.6354 0C6.10751 0 0 2.00008 0 4.45239V7.23511C0 9.68742 6.10751 11.6875 13.6354 11.6875C21.1633 11.6875 27.2708 9.68742 27.2708 7.23511Z"
        fill="#414042"
      />
      <path
        d="M27.2708 16.2012V10.7135C24.3413 12.731 18.9795 13.6702 13.6354 13.6702C8.29131 13.6702 2.92948 12.731 0 10.7135V16.9747C0 19.427 6.10751 21.4271 13.6354 21.4271C14.4522 21.4271 15.2522 21.4035 16.0295 21.3584C17.1652 18.0005 20.342 15.5833 24.0833 15.5833C25.2105 15.5833 26.2865 15.8027 27.2708 16.2012Z"
        fill="#414042"
      />
      <path
        d="M15.6131 23.3665C15.5934 23.6028 15.5833 23.8419 15.5833 24.0833C15.5833 26.8271 16.8834 29.2673 18.9011 30.8214C17.2808 31.0437 15.5018 31.1667 13.6354 31.1667C6.10751 31.1667 0 29.1666 0 26.7143V20.4531C2.92948 22.4706 8.29131 23.4098 13.6354 23.4098C14.2959 23.4098 14.9567 23.3955 15.6131 23.3665Z"
        fill="#414042"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.0833 34C29.5602 34 34 29.5602 34 24.0833C34 18.6065 29.5602 14.1667 24.0833 14.1667C18.6065 14.1667 14.1667 18.6065 14.1667 24.0833C14.1667 29.5602 18.6065 34 24.0833 34ZM24.0833 32.5833C28.7778 32.5833 32.5833 28.7778 32.5833 24.0833C32.5833 19.3889 28.7778 15.5833 24.0833 15.5833C19.3889 15.5833 15.5833 19.3889 15.5833 24.0833C15.5833 28.7778 19.3889 32.5833 24.0833 32.5833Z"
        fill="#414042"
      />
    </svg>
  );
}

export default SvgRestoreFromDatabase;
